import { Skeleton, Columns, Column } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import * as styles from "./OAuthAuthorizationStep.styles";

const SkeletonOAuthAuthorizationStep = () => {
  const { phoneLarge } = useBreakpoints();

  return (
    <div css={styles.main}>
      <div css={styles.header}>
        <Skeleton type="typography" typographySize="h1" margin="bottom" />
        <Skeleton type="typography" typographySize="h4" margin="bottomLarge" />
      </div>
      {[0, 1].map(item => (
        <div key={item} css={styles.skeletonScope}>
          <Columns>
            <Column columnWidth={1}>
              <Skeleton type="image" imageSize="medium" isCircular />
            </Column>
            <Column>
              <Skeleton type="typography" typographySize="h1" margin="bottom" />
              <Skeleton type="typography" typographySize="h4" margin="bottomLarge" />
            </Column>
          </Columns>
        </div>
      ))}

      <div css={styles.actions}>
        <Skeleton type="button" isFullWidth={phoneLarge.lessThan} />
      </div>
    </div>
  );
};

export { SkeletonOAuthAuthorizationStep };
